import styled from 'styled-components';

import {
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_2_XL,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_450,
  SYS_SPACE_FIXED_500,
  SYS_SPACE_FIXED_600,
} from '@oneaudi/unified-web-common';
import { LayoutItem } from '@oneaudi/unified-web-components';
import type { ContainerDivProps, TextWrapperProps } from '../../../@types/interfaces';

const PAGE_MARGIN = 'var(--page-margin)';

export const ContainerDiv = styled.div<ContainerDivProps>`
  ${process.env.IS_LEGACY
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (props) => `background-color: ${props?.theme?.sys?.color?.canvas?.default}`
    : ''};
  padding: ${(props) =>
    props.bottomMargin
      ? `var(--spacing-relative-xl) ${PAGE_MARGIN}`
      : `var(--spacing-relative-xl) ${PAGE_MARGIN} 0`};

  sup a {
    text-decoration: none;
    color: inherit;
  }

  .edirotial-text-headline {
    text-align: ${(props) => props.justification};
    margin: ${SYS_SPACE_FIXED_200} 0;
    display: block;
  }

  .first-paragraph {
    margin-top: ${SYS_SPACE_FIXED_600};
  }
  position: relative;
`;

export const TextLayout = styled.div<ContainerDivProps>`
  width: 100%;
  ${process.env.IS_LEGACY
    ? // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (props) => `background-color: ${props?.theme?.sys?.color?.canvas?.default}`
    : ''};
  padding: ${(props) => (props.bottomMargin ? `0 0 ${SYS_SPACE_FIXED_500}}` : `0`)};

  sup {
    line-height: normal;
  }

  ul {
    display: inline-block;
    ${({ justification }) =>
      justification === 'center'
        ? `
        margin: 0;
        padding: 0;
      `
        : ''};

    li {
      margin-left: 0 !important;

      ::before {
        left: unset;
        position: relative !important;
        margin-left: -26px !important;
      }
      ul li::before {
        margin-left: -38px !important;
      }
      sup a:-webkit-any-link {
        color: unset !important;
      }
      ul {
        display: block;
      }
    }
  }

  ol {
    display: inline-block;
    ${({ justification }) =>
      justification === 'center'
        ? `
        margin: 0;
        padding: 0;
      `
        : ''};

    li {
      ::before {
        left: unset;
      }
      sup a:-webkit-any-link {
        color: unset !important;
      }
    }
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    max-width: ${(props) => (props.reduceTextWidth ? '749px' : 'auto')};
    margin: 0 auto;
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}px) {
    max-width: ${(props) => (props.reduceTextWidth ? '849px' : 'auto')};
    margin: 0 auto;
  }

  blockquote {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }

  q {
    padding: 0 ${SYS_SPACE_FIXED_100};
    :before {
      content: '"';
    }
    :after {
      content: '"';
    }
  }
`;

export const StyledTextLayoutItem = styled(LayoutItem)`
  width: 100%;
`;

export const ButtonContainerDiv = styled.div<TextWrapperProps>`
  margin-block-start: ${SYS_SPACE_FIXED_450};
  margin-bottom: 0;
  text-align: ${({ align }) => align};
`;

export const TextWrapperDiv = styled.div<TextWrapperProps>`
  width: auto !important;
  text-align: ${(props) => props.align};

  pre {
    white-space: pre-wrap;
  }
`;
